import { Box } from "@mui/material"
import type { FC } from "react"

import WorkInProgressAlert from "@/components/common/Alerts/WorkInProgressAlert.tsx"

const PriceChangeHistoryContainer: FC = () => {
  return (
    <Box className='flex flex-col gap-6'>
      <WorkInProgressAlert title='Work in Progress' />
    </Box>
  )
}

export default PriceChangeHistoryContainer
